import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import RisingKeyword from '@/components/RisingKeyword';
import MonthlyKeyword from '@/components/MonthlyKeyword';
import DropDown from '@/components/DropDown';

import useStore from '@/hooks/useStore';

import { getRisingKeyword, getMonthlyKeyword } from '@/utils/api';
import ErrorBoundary from '@/components/common/ErrorBoundary';

const Main = () => {
  const { RisingKeywordStore, MonthlyKeywordStore, SEOStore } = useStore();
  const { setRisingKeywordData, setRisingTotalItemCount } = RisingKeywordStore;
  const { currentDate, setTotalRankingData, setPossibleDaysData, setCategoryData } = MonthlyKeywordStore;
  const { setSEOData } = SEOStore;

  useEffect(() => {
    const fetchData = async () => {
      const risingKeywordData = await getRisingKeyword();
      const monthlyKeywordData = await getMonthlyKeyword(currentDate);
      const { totalRankingItem, categoryItem, possibleDays } = monthlyKeywordData;
      const { seo } = risingKeywordData;

      setRisingKeywordData(risingKeywordData);
      setRisingTotalItemCount(risingKeywordData.totalItemCount);

      setTotalRankingData(totalRankingItem);
      setPossibleDaysData(possibleDays);
      setCategoryData(categoryItem);

      setSEOData(seo);
    };

    fetchData();
  }, [currentDate]);

  return (
    <div className="l_content">
      <div className="s_keyword" role="main">
        <div className="l_keyword_head">
          <div className="c-p-headline">
            <h2 className="c-p-headline__title">인기 키워드</h2>
          </div>
        </div>
        <div className="l_keyword_content">
          <ErrorBoundary groupName="Main > RisingKeyword">
            <RisingKeyword />
          </ErrorBoundary>
          <ErrorBoundary groupName="Main > MonthlyKeyword">
            <DropDown />
            <MonthlyKeyword />
          </ErrorBoundary>
        </div>
      </div>
    </div>
  );
};

export default observer(Main);
